var $ = jQuery.noConflict();

$( ".btn-dropdown" ).click(function() {
    $( this ).toggleClass( "active" );
});

$( ".menu-item-has-children>a" ).on( "click" ,function() {
    $( this ).parent().toggleClass( "active-hover" );
    return false;
});

$(document).click(function() {
    if($( '.btn-dropdown').hasClass("active-hover")){
         $( '.btn-dropdown').removeClass( "active" );
    }

     if($( '.menu-item-has-children').hasClass("active-hover")){
         $( '.menu-item-has-children').removeClass( "active-hover" );
    }
   
});